<template>
  <div class="page">
    <div class="banner">
      <el-carousel class="carousel-container" trigger="click" height="178px" arrow="always" indicator-position="outside" :autoplay="true">
        <span v-if="gender === 2">
        <el-carousel-item  key="1">
          <el-link href="https://api.tanmozz.com/user/policy?type=12&app_id=3" >
            <el-image style="width: 100%; height: 178px;" alt="玩法说明" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/tanyu/tanyu_wanfa.png"></el-image>
          </el-link>
        </el-carousel-item>
        </span>
        <el-carousel-item  key="2">
          <el-link href="https://api.tanmozz.com/user/policy?type=4&app_id=1" >
            <el-image style="width: 100%;height: 178px;" alt="自律公约" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/tanyu/tanyu_gongyue.png"></el-image>
          </el-link>
        </el-carousel-item>
        <el-carousel-item  key="3">
          <el-link href="https://api.tanmozz.com/user/policy?type=6&app_id=1" >
            <el-image style="width: 100%;height: 178px;" alt="防诈骗指南" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/tanyu/tanyu_fangpian.png"></el-image>
          </el-link>
        </el-carousel-item>
        <el-carousel-item  key="4">
          <el-link href="https://api.tanmozz.com/user/policy?type=13&app_id=1" >
            <el-image style="width: 100%;height: 178px;" alt="防掉线指南" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/tanyu/tanyu_fangdiaoxian.png"></el-image>
          </el-link>
        </el-carousel-item>
        <el-carousel-item  key="5">
<!--          <el-link href="https://apitest.tcty.tayu123.com/user/policy?type=13&app_id=3" >-->
            <el-image style="width: 100%;height: 178px;" alt="谨防诈骗" src="https://static-ty.oss-cn-shanghai.aliyuncs.com/banner/tanyu/tanyu_fangzhapian.png"></el-image>
<!--          </el-link>/-->
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="main-container">
      <div class="top">
        <div class="search-box" style="background-color: transparent;" @click="goAddPage('SearchPage')">
          <input  type="text" placeholder="问题搜索" class="search-input" />
        </div>
        <div class="icon-top" style="display: flex;margin-top: 0;">
          <div class="icon-item" @click="goAddPage('certification')">
            <img src="../assets/img/certification.png" class="quest-img">
            <p class="quest-char">认证问题</p>
          </div>
          <div class="icon-item" @click="goAddPage('account')">
            <img src="../assets/img/account.png"class="quest-img">
            <p class="quest-char">账号问题</p>
          </div>
          <div class="icon-item" @click="goAddPage('money')">
            <img src="../assets/img/money.png" class="quest-img">
            <p class="quest-char">金币问题</p>
          </div>
          <div class="icon-item" @click="goAddPage('integral')">
            <img src="../assets/img/integral.png" class="quest-img">
            <p class="quest-char">积分问题</p>
          </div>
        </div>
        <!--        <div class="icon-top" style="display: flex">
                  <div class="icon-item" @click="goAddPage('member')">
                    <img src="../assets/img/member.png" class="qest-img">
                  </div>
                  <div class="icon-item" @click="goAddPage('level')">
                    <img src="../assets/img/level.png" class="qest-img">
                  </div>
                  <div class="icon-item" @click="goAddPage('common')">
                    <img src="../assets/img/common.png" class="qest-img">
                  </div>
                </div>-->
      </div>

      <div class="content">
        <div class="content-topic">
          <div class="content-title"><img src="../assets/img/hot.png" style="width: 17px;margin-right: 5px;">热门问题</div>
          <el-collapse v-model="activeNames">
            <span v-for="(items, idx) in hotQuestion" :key="idx">
              <el-collapse-item :title="(idx+1) + '.' + items.title">
                <div class="item-content">
                  <div v-html="formatContent(items.content)"  @click="handleContentClick"></div>
                </div>
              </el-collapse-item>
            </span>
          </el-collapse>
        </div>
        <div class="content-topic">
          <div class="content-title"><img src="../assets/img/question.png" style="width: 17px;margin-right: 5px;">更多问题</div>

          <el-collapse v-model="activeNames">
            <span v-for="(items, idx) in moreQuestion" :key="idx">
              <el-collapse-item :title="(idx+1) + '.' + items.title">
              <div class="item-content" v-html="items.content"></div>
            </el-collapse-item>
            </span>
          </el-collapse>

        </div>

      </div>


    </div>
    <Service/>
  </div>
</template>

<script>
import Service from "./Service";
import axios from 'axios';

export default {
  name: 'Index',
  components: {Service},

  data() {
    return {
      activeNames: '',
      hotQuestion: [],
      moreQuestion:[],
      gender:2,
      imAction : {
        1:['做任务', 'toDayTask'],
        2:['每日任务', 'toDayTask'],
        3:['贵族','toVip'],
        4: ['贵族特享', 'toVip'],
        5:['真人认证', 'toRealPerson'],
        6:['金币清单', 'toGoldBill'],
        7:['积分清单', 'toIntegralBill'],
        8:['收费设置', 'toMoneySetting'],
        9:['上传头像', 'toAvatar'],
        10:['在线客服', 'toCustomer'],
        11:['消费记录', 'toIntegralBill'],
        12:['积分兑换', 'toIntegral'],
        13:['陌生约聊平台用户行为规范', 'userAgent'],
        14:['编辑语音签名', 'toVoiceFlag'],
        15:['温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。', 'toSign']
      }
    }
  },

  created() {
    this.gender  = this.getQueryParam('gender') === null ? 2 : parseInt(this.getQueryParam('gender'));
  },
  mounted() {
    axios.get(process.env.BASE_API + '/feedback', {'params':{'gender': this.gender}})
      .then(res => {
        if (res.data) {
          this.hotQuestion = res.data.data[1]
          this.moreQuestion = res.data.data[6]
        }
      })
      .catch(err => {
        console.error('请求feedback接口失败:', err);
      });
  },
  methods: {
    formatContent(content) {
      if (!content) return '';
      return content.replace(/(做任务|每日任务|贵族|贵族特享|真人认证|金币清单|积分清单|收费设置|上传头像|在线客服|消费记录|积分兑换|陌生约聊平台用户行为规范|编辑语音签名|温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。)/g, match => {
        return `<span class="highlight-action" style="color:cornflowerblue;cursor:pointer;">${match}</span>`;
      });
    },

    handleContentClick(e) {
      if (e.target.classList.contains('highlight-action')) {
        const text = e.target.innerText;
        switch (text) {
          case this.imAction[1][0]:
            this.handleSpanClick(this.imAction[1][1])
            break;
          case this.imAction[2][0]:
            this.handleSpanClick(this.imAction[2][1])
            break;
          case this.imAction[3][0]:
            this.handleSpanClick(this.imAction[3][1])
            break;
          case this.imAction[4][0]:
            this.handleSpanClick(this.imAction[4][1])
            break;
          case this.imAction[5][0]:
            this.handleSpanClick(this.imAction[5][1])
            break;
          case this.imAction[6][0]:
            this.handleSpanClick(this.imAction[6][1])
            break;
          case this.imAction[7][0]:
            this.handleSpanClick(this.imAction[7][1])
            break;
          case this.imAction[8][0]:
            this.handleSpanClick(this.imAction[8][1])
            break;
          case this.imAction[9][0]:
            this.handleSpanClick(this.imAction[9][1])
            break;
          case this.imAction[10][0]:
            this.handleSpanClick(this.imAction[10][1])
            break;
          case this.imAction[11][0]:
            this.handleSpanClick(this.imAction[11][1])
            break;
          case this.imAction[12][0]:
            this.handleSpanClick(this.imAction[12][1])
            break;
          case this.imAction[13][0]:
            this.handleSpanClick(this.imAction[13][1])
            break;
          case this.imAction[14][0]:
            this.handleSpanClick(this.imAction[14][1])
            break;
          case this.imAction[15][0]:
            this.handleSpanClick(this.imAction[15][1])
            break;
          default:
          // execute default code block
        }
      }
    },
    goAddPage(route) {
      this.$router.push(route);
    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },

    getQueryParam(param) {
      const query = window.location.search.substring(1);
      const vars = query.split('&');

      for (const item of vars) {
        const [key, value] = item.split('=');
        if (decodeURIComponent(key) === param) {
          return decodeURIComponent(value);
        }
      }
      return null;
    },
  }
}
</script>


<style scoped>

/*.page {
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: env(safe-area-inset-top);
}*/

.icon-top {
  margin-top: 10px;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-evenly;
  align-items: center;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 22px 0px;
}
.icon-top .quest-img{
  width: 55px;
}

.icon-item {
  //width: 25%;
  //height: 100%;
  border-radius: 8px;
}

.hr {
  height: 10px;
  width: 100%;
  background: #F9FAFC;
}

.content {
  width: 100%;
  font-size: 15px;
}

.title-class {
}

.content-title {
  margin-top: 10px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}

/deep/ .van-cell {
  color: #666666;
}

/deep/ .van-icon-circle2 {
  color: #3576F9;
}

/deep/ .van-icon-circle {
  color: #E6E5E5;
}

/deep/ .checked-title {
  font-size: 15px;
  color: #000000 !important;
}
/deep/ .unchecked {
  font-size: 15px;
}

.item-content {
  font-size: 13px;
  color: #555555;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.item-title {
  font-weight: 600;
}

.key-text{
  font-weight: 500;
  color: #4C30FC;
}

.item-img{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}



.top {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.quest-img {
  width: 100%;
  height: 80%;
}

.quest-char {
  text-align: center;
  font-size: 14px;
  color: #666;
}
.content .content-topic:last-child{
  margin-bottom: 70px;
}
.content-topic{
  padding: 10px 13px;
  background-color: #ffffff;
  border-radius: 10px;
  margin-top: 15px;
}
.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}
.content-topic .el-collapse-item__header {
  font-size: 15px;
}
.content-topic .last .el-collapse-item__header {
  border-bottom: none;
}
.customer-service {
  position: fixed;
  bottom: 30px;
  left: 80%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
}

.customer-service img {
  width: 100%;
  height: 100%;
}


.search-box {
  margin:0px 0 15px 0px;
  display: flex;
}

.search-input {
  height: 35px;
  width: 100%;
  background-color: #fff;
  border-radius: 20px;
  background-image: url(../assets/img/problem-search.png);
  background-repeat: no-repeat;
  background-position: 15px center;
  background-size: 21px;
  text-indent: 42px;
  border: none;
}

.red-text {
  color: red;
}

.blue-text {
  color: cornflowerblue;
}

.page .banner{
  width: 100%;
  border-right: 1px solid #eff2f6;
  display: inline-block;
  box-sizing: border-box;

}
.el-carousel__item a.el-link{
  display: block;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}


.carousel-container {
  // 使用Vue2支持的深度选择器语法
  /deep/ .el-carousel__button {
    width: 20px;
    height: 6px; /* 需要同时设置高度 */
    border-radius: 3px; /* 修改默认圆形为胶囊形 */
    background-color: #409EFF; /* 覆盖默认背景色 */
  }
}


.el-carousel__item:nth-child(2n) {
  background-color: #ffffff;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #ffffff;
}


.page{
  position: relative;
}
.main-container{
  border-radius: 23px 23px 10px 10px;
  margin-top: -55px;
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}
</style>



// WEBPACK FOOTER //
// src/page/Index.vue